<template>
  <div>
    <v-dialog v-model="showDialog" width="500" persistent>
      <v-card dark>
        <v-card-title class="text-h5"> WARNING</v-card-title>
        <v-divider></v-divider>
        <v-alert text prominent type="error" icon="mdi-alert" class="tw-p-5 tw-m-5">
          <strong>Your account has been suspended. Please contact 2ez.bet Customer Service here.</strong>
        </v-alert>
        <v-divider></v-divider>
        <div class="tw-p-5">
          <div class="tw-mb-5">
            <strong>
              If you think this is a mistake. Please contact our
              <a href="https://facebook.com/" _target="_blank">support</a> in our facebook page.
            </strong>
          </div>
          <div>
            <v-btn class="tw-h-full tw-rounded-md" color="#D3AE37" dark @click="gotoHome">
              <strong>Okay</strong>
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex/dist/vuex.common.js";

export default {
  props: ["show", "errors"],
  data() {
    return {
      showDialog: false,
    };
  },
  computed: {
    userStatus() {
      try {
        if (this.$cookies.isKey("_user_status")) return this.$cookies.get("_user_status");
      } catch (e) {
        console.log(e);
      }
      return null;
    },
    isBanned() {
      if (this.userStatus) {
        return this.userStatus?.isBanned;
      }
      return false;
    },

    isOnHold() {
      if (this.userStatus) {
        return this.userStatus?.onHold;
      }
      return false;
    },
  },
  watch: {
    isBanned() {
      if (this.isBanned) {
        this.showDialog = true;
      }
    },
    showDialog() {
      if (this.showDialog) {
        this.userValidate();
        this.$cookies.remove("_user_status");
        this.$cookies.remove("_token");
        this.$cookies.remove("laravel_session");
      }
    },
  },
  methods: {
    ...mapActions("user", ["userValidate"]),
    gotoHome() {
      this.showDialog = false;
      this.$cookies.remove("_user_status");
      return (location.href = process.env.VUE_APP_SERVER_ENV == "prod" ? "/casino-games" : "/");
    },
  },
};
</script>
